import { Button } from "antd";
import React from 'react';
import Icon, { ICON_NAME } from "../../../components/Icon";
import modal from "../../../components/Popup/ModalCustom";
import { nextPage } from "../../../util/library/Router";
import { OpService } from '../../../util/services/operation';
import { selectOpDetail, selectTenantId } from '../../../util/store/selectors';
import { useSelector } from '../../../util/store/store';
import { PATHNAME } from "../../../util/varibles/constants";
import { showErrorResponse } from "../../../util/varibles/global";
import { notify, NotifyCode } from "../../../util/varibles/message";

interface IProps {
}

const TitleRight: React.FC<IProps> = () => {
    const op = useSelector(selectOpDetail.data);
    const tenantId = useSelector(selectTenantId);
    const { tenant_id: opTenantId } = op?.operation || {};
    const [loading, setLoading] = React.useState(false);

    if (opTenantId !== tenantId) return null;

    const handleDelete = () => {
        modal.confirm({
            content: 'Are you sure you want to delete this operation?',
            subContent: 'Note: Delete this operation may cause duration changing on next operation (if have any) due to vessel’s start position.',
            ok: {
                click: () => {
                    setLoading(true);
                    OpService.delete(op.operation.id)
                        .then(rs => {
                            notify.success(NotifyCode.S5)([`#${op.operation.operation_code}`]);
                            setLoading(false);
                            setTimeout(() => nextPage(PATHNAME.HOME), 300);
                        })
                        .catch(err => {
                            setLoading(false);
                            showErrorResponse("Delete operation failure", err);
                        })
                }
            }
        });
    };

    return <Button className='mr-10 hidden min-[1290px]:inline-flex' type="text" danger shape="circle" onClick={handleDelete} loading={loading}>
        <Icon icon={ICON_NAME.DELETE} danger />
    </Button>
};

export default TitleRight;
